const initState = {
  talkingBadges: [],
  seasonalBadges: [],
  MomentoBadges: [],
  chatBadges: [],
  strategyBadges: [],
  myJobs: [],
  requestedJobs: [],
  allJobs: [],
  appliedJobs: [],
  lastVisibleMyJobs: null,
  lastVisibleRequestedJobs: null,
  lastVisibleAppliedJobs: null,
  lastVisible: null,
  hasMoreDocument: true,
  hasMoreMyJobs: true,
  hasMoreRequestedJobs: true,
  hasMoreAppliedJobs: true,
};

const jobsReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_TALKING_BADGE":
      return {
        ...state, 
        talkingBadges: action.payload,
      };
    case "GET_SEASONAL_BADGE":
      return {
        ...state,
        seasonalBadges: action.payload,
      };
    case "GET_MOMENTO_BADGES":
      return {
        ...state,
        MomentoBadges: action.payload,
      };
    case "GET_CHAT_BADGES":
      return {
        ...state,
        chatBadges: action.payload,
      };
    case "GET_STRATEGY_RATING":
      return {
        ...state,
        strategyBadges: action.payload,
      };
    case "FETCH_MYJOBS_SUCCESS":
      return {
        ...state,
        myJobs: action.payload.jobs,
        lastVisibleMyJobs: action.payload.lastVisible,
        hasMoreMyJobs: action.payload.hasMoreDocument,
      };
    case "FETCH_REQUESTED_JOBS_SUCCESS":
      return {
        ...state,
        requestedJobs: action.payload.jobs,
        lastVisibleRequestedJobs: action.payload.lastVisible,
        hasMoreRequestedJobs: action.payload.hasMoreDocument,
      };
    case "FETCH_APPLIED_JOBS_SUCCESS":
      return {
        ...state,
        appliedJobs: action.payload.jobs,
        lastVisibleAppliedJobs: action.payload.lastVisible,
        hasMoreAppliedJobs: action.payload.hasMoreDocument,
      };
    case "FETCH_ALL_JOBS_SUCCESS":
      return {
        ...state,
        allJobs: action.payload.jobs,
        lastVisible: action.payload.lastVisible,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "FETCH_ALL_JOBS_LOAD_MORE":
      return {
        ...state,
        allJobs: [...state.allJobs, ...action.payload.jobs],
        lastVisible: action.payload.lastVisible,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "FETCH_MYJOBS_LOAD_MORE":
      return {
        ...state,
        myJobs: [...state.myJobs, ...action.payload.jobs],
        lastVisibleMyJobs: action.payload.lastVisible,
        hasMoreMyJobs: action.payload.hasMoreDocument,
      };
    case "FETCH_REQUESTED_JOBS_LOAD_MORE":
      return {
        ...state,
        requestedJobs: [...state.requestedJobs, ...action.payload.jobs],
        lastVisibleRequestedJobs: action.payload.lastVisible,
        hasMoreRequestedJobs: action.payload.hasMoreDocument,
      };
    case "FETCH_APPLIED_JOBS_LOAD_MORE":
      return {
        ...state,
        appliedJobs: [...state.appliedJobs, ...action.payload.jobs],
        lastVisibleAppliedJobs: action.payload.lastVisible,
        hasMoreAppliedJobs: action.payload.hasMoreDocument,
      };
    default:
      return state;
  }
};

export default jobsReducer;
